type IconName =
  | 'dashboard'
  | 'car'
  | 'wrench'
  | 'box'
  | 'scan'
  | 'sparkles'
  | 'users'
  | 'flag'
  | 'plus'
  | 'alert'
  | 'clock'
  | 'logout'
  | 'tag'
  | 'trash'
  | 'link'
  | 'truck'
  | 'cart'
  | 'mail'
  | 'archive';

const paths: Record<IconName, string> = {
  dashboard: 'M3 3h8v8H3V3zm10 0h8v5h-8V3zM3 13h8v8H3v-8zm10 3h8v5h-8v-5z',
  car: 'M5 11l1.5-4.5A2 2 0 0 1 8.4 5h7.2a2 2 0 0 1 1.9 1.5L19 11m-14 0h14m-14 0a2 2 0 0 0-2 2v3h2m14-5a2 2 0 0 1 2 2v3h-2m-12 0h10m-10 0v2H5v-2m12 0v2h2v-2M7 16h.01M17 16h.01',
  wrench:
    'M14.7 6.3a4 4 0 0 0-5.4 5.4l-5 5a2 2 0 1 0 2.8 2.8l5-5a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.3-.2-.2-2.3 2.5-2.5z',
  box: 'M21 8l-9-5-9 5m18 0l-9 5m9-5v8l-9 5m0-8L3 8m9 5v8M3 8v8l9 5',
  scan: 'M4 7V5a1 1 0 0 1 1-1h2m10 0h2a1 1 0 0 1 1 1v2M4 17v2a1 1 0 0 0 1 1h2m10 0h2a1 1 0 0 0 1-1v-2M4 12h16',
  sparkles: 'M12 3l1.9 4.6L18.5 9l-4.6 1.4L12 15l-1.9-4.6L5.5 9l4.6-1.4L12 3zm6 9l.9 2.2 2.1.8-2.1.8L18 18l-.9-2.2-2.1-.8 2.1-.8L18 12z',
  users:
    'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM3 21v-1a6 6 0 0 1 6-6h6a6 6 0 0 1 6 6v1',
  flag: 'M5 21V4m0 0h13l-2 4 2 4H5',
  plus: 'M12 5v14M5 12h14',
  alert: 'M12 9v4m0 4h.01M10.3 3.9L2 18a1.5 1.5 0 0 0 1.3 2.2h17.4A1.5 1.5 0 0 0 22 18L13.7 3.9a1.5 1.5 0 0 0-2.6 0z',
  clock: 'M12 8v4l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4m7 14l5-5-5-5m5 5H9',
  tag: 'M2 12l8.6-8.6a2 2 0 0 1 1.4-.6H19a2 2 0 0 1 2 2v6.6a2 2 0 0 1-.6 1.4L12 22 2 12zm5-3h.01',
  trash: 'M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6m4 5v6m4-6v6',
  link: 'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 1 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 1 0 7 7l1-1',
  truck: 'M3 6h11v9H3V6zm11 3h4l3 3v3h-7V9zM7 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm12 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z',
  cart: 'M3 3h2l.4 2M7 13h10l3-8H6.4M7 13l-2.3-8M7 13l-1.5 4.5h12M9 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z',
  mail: 'M3 7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7zm0 .5l9 6 9-6',
  archive: 'M3 4h18v4H3V4zm1 4v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8M9 12h6',
};

export function Icon({
  name,
  className = 'h-5 w-5',
  strokeWidth = 1.8,
}: {
  name: IconName;
  className?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
